/* eslint-disable unicorn/prefer-export-from, import/no-named-as-default, import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import itCommon from './locales/it/common.json';

// Try to infer the preferred language from persisted appConfig
function getInitialLanguage(): 'en' | 'es' | 'it' {
  try {
    const raw = localStorage.getItem('appConfig');
    if (!raw) return 'en';
    const parsed = JSON.parse(raw) as { language?: unknown };
    const lang = typeof parsed.language === 'string' ? parsed.language.toLowerCase() : 'en';
    if (lang === 'es') return 'es';
    if (lang === 'it') return 'it';
    return 'en';
  } catch {
    return 'en';
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    es: { common: esCommon },
    it: { common: itCommon },
  },
  fallbackLng: 'en',
  lng: getInitialLanguage(),
  ns: ['common'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
